import { create } from 'zustand';

import { Interval } from '@/types/types';

interface IntervalCommentsDrawerState {
  intervalId: Interval['id'] | null;
  taskName: string | null;
  open: (intervalId: Interval['id'], taskName: string | null) => void;
  close: () => void;
}

export const useIntervalCommentsDrawerStore = create<IntervalCommentsDrawerState>((set) => ({
  intervalId: null,
  taskName: null,
  open: (intervalId, taskName) => set({ intervalId, taskName }),
  close: () => set({ intervalId: null, taskName: null }),
}));
